import { Injectable } from '@angular/core';
import { GuideCategoryUrl } from '@uc/web/shared/data-models';

@Injectable({
	providedIn: 'root',
})
export class GuidesService {
	getCategoryId(category: GuideCategoryUrl): number {
		switch (category) {
			case 'subject':
				return 1;
			case 'city':
				return 2;
			case 'career':
				return 3;
			default:
				return 0;
		}
	}

	getGuideCategory = (guideCategoryId: number): string => {
		if (guideCategoryId === 3) {
			return 'Career Guide';
		} else if (guideCategoryId == 2) {
			return 'City Guide';
		} else {
			return 'Subject Guide';
		}
	};
}
